import React, { useEffect, useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import servicio_imagen_1 from "../../../images/servicio_image_1.png";
import { Box, Button, Modal, TextField, IconButton, Typography, CircularProgress, Skeleton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import { ApiService } from "../../ApiService";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { grey } from "@mui/material/colors";
import { toast } from "react-toastify";

function parseParentheses(text) {
	const parts = text.split(/(\*.*?\*)/);
	return parts.map((part, i) => {
		if (/^\*.*\*$/.test(part)) {
			return (
				<span key={i} style={{ color: "#3968fb", fontWeight: 800 }}>
					{part.slice(1, -1)}
				</span>
			);
		}
		return <React.Fragment key={i}>{part}</React.Fragment>;
	});
}

const HomeServicioEdit = ({
	empresaDetails,
	keyBranch,
	currentIndex,
	images,
	handlePrev,
	handleNext,
	onImageUpdateSuccess,
}) => {
	const [preview, setPreview] = useState(null);

	const { nit } = useParams();
	
	const [editingField, setEditingField] = useState(null);
	const [tempText, setTempText] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [texts, setTexts] = useState({
		title: "",
		text: "",
	});
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedImages, setSelectedImages] = useState(Array(3).fill(null));
	const [tempImages, setTempImages] = useState([]);
	const [details, setDetails] = useState({});
	const [apiUrl] = useState(process.env.REACT_APP_API_URL);
	useEffect(() => {
		if (empresaDetails) {
			setDetails(empresaDetails);
			setTexts({
				title: empresaDetails.title || "Título de vista aquí...",
				text: empresaDetails.text || "Ingresa el texto que quieras mostrar en esta vista",
			});
			if (empresaDetails.img_list && Array.isArray(empresaDetails.img_list)) {
				setSelectedImages(empresaDetails.img_list);
			} else {
				setSelectedImages(Array(3).fill(null));
			}
		}
	}, [empresaDetails, keyBranch]);
	const [localPreviews, setLocalPreviews] = useState({});
	const handleTextClick = (field) => {
		if (editingField !== null && editingField !== field) {
			setEditingField(field);
			setTempText(texts[field]);
		} else {
			setEditingField(field);
			setTempText(texts[field]);
		}
	};
	const handleKeyDown = (e) => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault();
			handleSave();
		}
	};

	const handleSave = async () => {
		setIsLoading(true);
		try {
			const updatedData = {
				view2: {
					[editingField]: tempText,
				},
			};
			const updateResponse = await ApiService.fetchData(`api/company/update/main?key_branch=${keyBranch}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(updatedData),
			});

			if (updateResponse?.code === 200) {
				toast.success(updateResponse.message);
				setTexts({ ...texts, [editingField]: tempText });
				if (typeof onImageUpdateSuccess === "function") {
					onImageUpdateSuccess();
				}
			}
		} catch (error) {
			console.error("Error updating text:", error);
		} finally {
			setIsLoading(false);
			setEditingField(null);
		}
	};

	const handleCancel = () => {
		setEditingField(null);
	};

	const handleImageChange = async (e) => {
		if (!e.target.files || !e.target.files[0]) return;
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onload = async (evt) => {
			const previewData = evt.target.result;
			setPreview(previewData);
			setIsLoading(true);
			try {
				const formData = new FormData();
				formData.append("file", file);
				const uploadResponse = await ApiService.fetchData(
					"api/upload/file",
					{ method: "POST", body: formData },
					false
				);

				if (uploadResponse && uploadResponse.url) {
					const newTempImage = uploadResponse.url;
					setLocalPreviews((prev) => ({
						...prev,
						[newTempImage]: previewData,
					}));
					setTempImages((prev) => [...prev, newTempImage]);
					setPreview(null);
				}
			} catch (error) {
				console.error("Error uploading image:", error);
				toast.error("Error uploading image. Please try again.");
			} finally {
				setIsLoading(false);
			}
		};
		reader.readAsDataURL(file);
	};
	const removeImage = (index) => {
		const urlToRemove = tempImages[index];
		setTempImages((prev) => prev.filter((_, i) => i !== index));
		setLocalPreviews((prev) => {
			const updated = { ...prev };
			delete updated[urlToRemove];
			return updated;
		});
	};
	const handleEliminarPreview = () => {
		setPreview(null);
	};
	const handleAcceptImages = async () => {
		setIsLoading(true);
		try {
			const fixedSizeArray = [...tempImages.slice(0, 3)];
			while (fixedSizeArray.length < 3) {
				fixedSizeArray.push(null);
			}
			const updatedData = {
				view2: {
					img_list: fixedSizeArray,
				},
			};
			const updateResponse = await ApiService.fetchData(`api/company/update/main?key_branch=${keyBranch}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(updatedData),
			});
			if (updateResponse) {
				setSelectedImages(fixedSizeArray);
				setPreview(null);
				if (typeof onImageUpdateSuccess === "function") {
					onImageUpdateSuccess();
				}
			}
		} catch (error) {
			console.error("Error updating images:", error);
		} finally {
			setIsLoading(false);
			setModalOpen(false);
		}
	};
	const handleOpenModal = () => {
		const validImages = selectedImages.filter((img) => img !== null) || [];
		setTempImages(validImages);
		setModalOpen(true);
		setPreview(null); // Clear any existing preview
	};
	const getValidImages = () => {
		return selectedImages.filter((img) => img !== null);
	};
	const finalImages = getValidImages();
	const safeCurrentIndex = finalImages.length > 0 ? currentIndex % finalImages.length : 0;

	const handleDeleteCarouselImage = async (index) => {
		if (!keyBranch || isLoading) return;
		setIsLoading(true);
		try {
			const updatedImages = [...selectedImages];
			updatedImages[index] = null;
			const updatedData = {
				view2: {
					img_list: updatedImages,
				},
			};
			const updateResponse = await ApiService.fetchData(`api/company/update/main?key_branch=${keyBranch}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(updatedData),
			});
			if (updateResponse?.code === 200) {
				setSelectedImages(updatedImages);
				toast.success(updateResponse.message);
				if (typeof onImageUpdateSuccess === "function") {
					onImageUpdateSuccess();
				}
			}
		} catch (error) {
			console.error("Error deleting image:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const getOriginalIndex = (imageUrl) => {
		return selectedImages.findIndex((img) => img === imageUrl);
	};
	const handleCloseModal = () => {
		if (isLoading) return;
		setModalOpen(false);
		setPreview(null);
	};
	const renderSkeleton = () => {
		return (
			<div className="services-company">
				<div className="services-top">
					<div className="top-one">
						{/* Skeleton for top image */}
						<Skeleton
							variant="rectangular"
							width="100%"
							height={120}
							sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
						/>
						<div className="services-setting">
							{/* Skeleton for title */}
							<Skeleton
								variant="text"
								width={200}
								height={40}
								sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
							/>
						</div>
					</div>
				</div>

				<div className="services-center">
					<Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
								background: "#232323",
								padding: "20px",
								position: "relative",
								borderRadius: "8px",
								width: "80%",
								maxWidth: "1000px",
								zIndex: 1,
							}}>
							{/* Skeleton for left arrow */}
							<Skeleton
								variant="circular"
								width={40}
								height={40}
								sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
							/>

							{/* Skeleton for carousel image */}
							<Skeleton
								variant="rectangular"
								width={800}
								height={450}
								sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
							/>

							{/* Skeleton for right arrow */}
							<Skeleton
								variant="circular"
								width={40}
								height={40}
								sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
							/>
						</Box>
					</Box>
				</div>

				<div className="services-bottom">
					{/* Skeleton for bottom text */}
					<Skeleton
						variant="text"
						width="60%"
						height={100}
						sx={{
							bgcolor: "rgba(255, 255, 255, 0.1)",
							mx: "auto",
						}}
					/>

					<div className="square-grid-container">
						{/* Skeletons for the grid squares */}
						{[...Array(6)].map((_, i) => (
							<Skeleton
								key={i}
								variant="rectangular"
								width="100%"
								height="100%"
								sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
							/>
						))}
					</div>
				</div>
			</div>
		);
	};
	return !empresaDetails ? (
		renderSkeleton()
	) : (
		<div className="services-company">
			<div className="services-top">
				<div className="top-one">
					<img className="service-top-image-one" src={servicio_imagen_1} alt="services" />
					<div className="services-setting">
						<SettingsIcon sx={{ fontSize: 40, color: 'var(--theme-company)' }} className="setting-icon" />
						{editingField === "establecimiento" ? (
							<Box width="100%" sx={{ display: "flex", flexDirection: "row", gap: "10px" }}>
								<TextField
									fullWidth
									value={tempText}
									onChange={(e) => setTempText(e.target.value)}
									multiline
									onKeyDown={handleKeyDown}
									sx={{
										"& .MuiInputBase-root": {
											fontSize: "18px",
											color: "#fff",
											fontWeight: 600,
										},
									}}
								/>
								<Box mt={1} display="flex" gap={1}>
									<Button
										sx={{ height: "50px" }}
										variant="contained"
										onClick={handleSave}
										disabled={isLoading}>
										{isLoading ? <CircularProgress size={24} /> : "Guardar"}
									</Button>
									<Button
										sx={{ height: "50px" }}
										variant="outlined"
										onClick={handleCancel}
										disabled={isLoading}>
										Cancelar
									</Button>
								</Box>
							</Box>
						) : (
							<span onClick={() => handleTextClick("title")} style={{ cursor: "pointer" }}>
								{texts.title || "Título de vista aquí..."}
							</span>
						)}
					</div>
				</div>
			</div>
			<div className="services-center">
				<Box
					sx={{
						width: "100%",
						display: "flex",
						justifyContent: "center",
						px: { xs: 1, sm: 2, md: 3 },
					}}>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: { xs: 1, sm: 2 },
							background: "#232323",
							padding: { xs: "8px", sm: "12px", md: "16px" },
							position: "relative",
							borderRadius: "8px",
							width: "100%",
							maxWidth: "1400px",
							zIndex: 1,
						}}>
						{/* Botón izquierdo */}
						<IconButton
							onClick={handlePrev}
							sx={{
								zIndex: 2,
								position: "relative",
							}}>
							<ArrowBackIosNewRoundedIcon sx={{ color: grey[50] }} />
						</IconButton>

						{/* Imagen del carrusel */}
						{finalImages.length > 0 ? (
							<Box
								sx={{
									position: "relative",
									width: "100%", // Take full width
									display: "flex",
									justifyContent: "center",
									height: { xs: "160px", sm: "250px", md: "450px" }, // Reduced height at all breakpoints
								}}>
								<img
									className="carousel-image-company"
									src={`${apiUrl}${finalImages[safeCurrentIndex]}`}
									alt={`Imagen-${safeCurrentIndex}`}
									onClick={handleOpenModal}
									style={{
										width: "100%", // Take full width
										height: "100%", // Take full height of container
										objectFit: "cover", // Keep cover to fill and crop if needed
										cursor: "pointer",
									}}
								/>
								{/* Delete button */}
								<IconButton
									onClick={(e) => {
										e.stopPropagation();
										const originalIndex = getOriginalIndex(finalImages[safeCurrentIndex]);
										if (originalIndex !== -1) {
											handleDeleteCarouselImage(originalIndex);
										}
									}}
									size="small"
									disabled={isLoading}
									sx={{
										"position": "absolute",
										"top": 10,
										"right": 10,
										"zIndex": 10,
										"backgroundColor": "rgba(255, 0, 0, 0.7)",
										"&:hover": { backgroundColor: "rgba(255, 0, 0, 0.9)" },
									}}>
									<DeleteIcon sx={{ color: "#fff" }} />
								</IconButton>
							</Box>
						) : (
							<Box
								className="carousel-image-company placeholder-image"
								onClick={handleOpenModal}
								sx={{
									width: "100%", // Take full width
									height: { xs: "160px", sm: "220px", md: "280px" }, // Reduced height to match
									backgroundColor: "#f0f0f0",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									cursor: "pointer",
								}}>
								<Typography>Sin imágenes</Typography>
							</Box>
						)}
						<IconButton
							onClick={handleNext}
							sx={{
								zIndex: 2,
								position: "relative",
							}}>
							<ArrowForwardIosRoundedIcon sx={{ color: grey[50] }} />
						</IconButton>
					</Box>
				</Box>
			</div>
			<div className="services-bottom">
				{editingField === "text" ? (
					<Box width="80%" px={2}>
						{/* Mensaje de que ( ) se colorea en azul */}
						<Typography color="text.secondary" sx={{ fontSize: "16px", color: "#fff" }}>
							Para colocar en azul usa "*" Ej: *Servicio*
						</Typography>
						<TextField
							fullWidth
							value={tempText}
							onKeyDown={handleKeyDown}
							onChange={(e) => setTempText(e.target.value)}
							multiline
							sx={{
								"& .MuiInputBase-root": {
									fontSize: "18px",
									color: "#fff",
									fontWeight: 600,
								},
							}}
						/>
						<Box mt={1} display="flex" gap={1}>
							<Button variant="contained" onClick={handleSave} disabled={isLoading}>
								{isLoading ? <CircularProgress size={24} /> : "Guardar"}
							</Button>
							<Button variant="outlined" onClick={handleCancel} disabled={isLoading}>
								Cancelar
							</Button>
						</Box>
					</Box>
				) : (
					<h2
						onClick={() => handleTextClick("text")}
						style={{ cursor: "pointer", width: "60%", textAlign: "center" }}>
						{/* Parseamos el texto y lo coloreamos en azul si está dentro de asteriscos */}
						{parseParentheses(texts.text || "Ingresa el texto que quieras mostrar en esta vista")}
					</h2>
				)}

				<div className="square-grid-container">
					{[...Array(6)].map((_, i) => (
						<div className="box-ser" style={{ background: 'var(--theme-company)' }} key={i}></div>
					))}
				</div>
			</div>
			{/* Modal para imágenes */}
			<Modal open={modalOpen} onClose={handleCloseModal}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "#fff",
						p: {
							xs: 2,
							md: 4,
						},
						borderRadius: 2,
						width: {
							xs: '98%',
							md: 500,
						},
					}}>
					<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
						<h3 style={{fontSize:'22px'}}>Selecciona hasta 3 imágenes</h3>
						<IconButton onClick={handleCloseModal}>
							<CloseIcon />
						</IconButton>
					</Box>

					<Box display="flex" gap={2} flexWrap="wrap" mb={2}>
						{/* Existing uploaded images - using correctly formatted URLs */}
						{tempImages.map((src, i) => (
							<Box key={i} position="relative">
								<img
									src={
										// For newly uploaded images, use the local preview
										localPreviews[src] && src.includes("temporal/")
											? localPreviews[src]
											: // For existing images, use the same approach as the carousel
												`${apiUrl}${src}`
									}
									alt={`Imagen ${i + 1}`}
									style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 4 }}
									onError={(e) => {
										console.error("Image failed to load:", src);
										e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Crect width='120' height='120' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' font-size='14' text-anchor='middle' dominant-baseline='middle' fill='%23555'%3EImagen ${i + 1}%3C/text%3E%3C/svg%3E`;
									}}
								/>
								<IconButton
									onClick={() => !isLoading && removeImage(i)}
									size="small"
									disabled={isLoading}
									sx={{
										position: "absolute",
										top: 0,
										right: 0,
										zIndex: 10,
										backgroundColor: "#fff",
									}}>
									<DeleteIcon fontSize="small" />
								</IconButton>
							</Box>
						))}

						{/* Preview if it exists */}
						{preview && (
							<Box position="relative">
								<img
									src={preview}
									alt=""
									style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 4 }}
								/>
								<IconButton
									onClick={handleEliminarPreview}
									size="small"
									disabled={isLoading}
									sx={{
										position: "absolute",
										top: 0,
										right: 0,
										zIndex: 10,
										backgroundColor: "red",
									}}>
									<CloseIcon fontSize="small" sx={{ color: "#fff" }} />
								</IconButton>
							</Box>
						)}

						{/* "Nueva Imagen" button - Only show if we don't have a preview and haven't reached maximum */}
						{!preview && tempImages.length < 3 && (
							<Box
								component="label"
								htmlFor="upload-images"
								sx={{
									width: 120,
									height: 120,
									border: "2px dashed #ccc",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									cursor: "pointer",
									borderRadius: 2,
									paddingLeft: 0,
								}}>
								Nueva Imagen
								<input
									id="upload-images"
									type="file"
									accept="image/*"
									hidden
									onChange={handleImageChange}
								/>
							</Box>
						)}
					</Box>

					<Box textAlign="right">
						<Button variant="contained" onClick={handleAcceptImages} disabled={isLoading}>
							{isLoading ? <CircularProgress size={24} /> : "Aceptar"}
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default HomeServicioEdit;
